export const queryDomain = `https://prfbackend.cbtseminary.com`